/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface Download$Params {
  pkAttachmentId: number;
}

export function download(
  http: HttpClient,
  rootUrl: string,
  params: Download$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, download.PATH, 'get');
  if (params) {
    rb.path('pkAttachmentId', params.pkAttachmentId, {});
  }

  return http.request(rb.build({ responseType: 'blob', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    }),
  );
}

download.PATH = '/service/v1/attachment/download/{pkAttachmentId}';
